// ─── MSAN Mockup Placeholder ────────────────────────────────────────────────
// Placeholder shown when MSAN preview is not available.

import { Monitor } from 'lucide-react';

export function MSANMockup() {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-center px-6">
        <div className="w-14 h-14 rounded-2xl bg-slate-100 flex items-center justify-center">
          <Monitor className="w-7 h-7 text-slate-400" />
        </div>
        <div>
          <p className="text-sm font-semibold text-slate-500">MSAN Preview</p>
          <p className="text-xs text-slate-400 mt-1">Preview not supported for this format</p>
        </div>
        <div className="w-48 space-y-2 mt-2">
          <div className="h-2 bg-slate-100 rounded-full" />
          <div className="h-2 bg-slate-100 rounded-full w-3/4" />
          <div className="h-2 bg-slate-100 rounded-full w-1/2" />
        </div>
      </div>
    </div>
  );
}
